import React from 'react';

const Step3Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-3">
        L'inclinazione prevalente in Italia è pari a 20°; in alta montagna siamo intorno ai 40° e oltre.
        </div>
    );
}

export default Step3Infos;